var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FF5177"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6052 6.30894L15.5777 6.37311L12.9194 12.5423H10.3069C9.68354 12.5423 9.08771 12.6706 8.54688 12.8998L10.151 9.06811L10.1877 8.97644L10.2519 8.82978C10.2702 8.77478 10.2885 8.71978 10.316 8.67394C11.5169 5.89644 12.8735 5.26394 15.6052 6.30894Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5446 12.7253C20.1321 12.5969 19.6921 12.5419 19.2521 12.5419H12.918L15.5763 6.37276L15.6038 6.30859C15.7413 6.35443 15.8696 6.41859 16.0071 6.47359L18.033 7.32609C19.1605 7.79359 19.9488 8.27943 20.4255 8.86609C20.5171 8.97609 20.5905 9.07693 20.6546 9.19609C20.7371 9.32443 20.8013 9.45276 20.838 9.59026C20.8746 9.67276 20.9021 9.75526 20.9205 9.82859C21.168 10.5986 21.0213 11.5428 20.5446 12.7253Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7279 17.0143V18.8018C23.7279 18.9852 23.7188 19.1685 23.7096 19.3518C23.5354 22.551 21.7479 24.1643 18.3562 24.1643H11.2063C10.9863 24.1643 10.7662 24.146 10.5554 24.1185C7.64042 23.926 6.08208 22.3677 5.88958 19.4527C5.86208 19.2418 5.84375 19.0218 5.84375 18.8018V17.0143C5.84375 15.1718 6.96208 13.586 8.55708 12.8985C9.10708 12.6693 9.69375 12.541 10.3171 12.541H19.2637C19.7129 12.541 20.1529 12.6052 20.5562 12.7243C22.3804 13.2835 23.7279 14.9885 23.7279 17.0143Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1495 9.06641L8.54536 12.8981C6.95036 13.5856 5.83203 15.1714 5.83203 17.0139V14.3281C5.83203 11.7247 7.6837 9.55224 10.1495 9.06641Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7264 14.329V17.0148C23.7264 14.9982 22.388 13.284 20.5547 12.734C21.0314 11.5423 21.1689 10.6073 20.9397 9.82818C20.9214 9.74568 20.8939 9.66318 20.8572 9.58984C22.5622 10.4698 23.7264 12.2757 23.7264 14.329Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.4986283b3d4f6fd6be7835e6b019932c.svg";
export { ForwardRef as ReactComponent };